import Button from '@pinecast/common/Button';
import Group, {VerticalGroup} from '@pinecast/common/Group';
import {OptionButtonWithRadio} from '@pinecast/common/OptionButton';
import {DashboardTitle, P} from '@pinecast/common/Text';
import {FormattedMessage} from '@pinecast/i18n';
import {useCSS} from '@pinecast/styles';
import * as React from 'react';

type Frequency = 'oneTime' | 'recurring';

const TipFrequency = ({
  onChange,
}: {
  onChange: (frequency: Frequency) => void;
}) => {
  const css = useCSS();

  const [option, setOption] = React.useState<Frequency | null>(null);
  const [pending, setPending] = React.useState(false);
  return (
    <>
      <DashboardTitle>
        <FormattedMessage
          description="Label for subscription duration"
          defaultMessage="Subscribe for one month or set up a recurring subscription?"
        />
      </DashboardTitle>
      <VerticalGroup spacing={16}>
        <Group role="radiogroup" spacing={8} wrapperStyle={{marginTop: '-8px'}}>
          <OptionButtonWithRadio
            alignInput="top"
            name="tjfreq"
            onClick={() => {
              setOption('oneTime');
            }}
            selected={option === 'oneTime'}
          >
            <FormattedMessage
              description="Label for option to send a one-month subscription"
              defaultMessage="Just one month"
            />
          </OptionButtonWithRadio>
          <OptionButtonWithRadio
            alignInput="top"
            name="tjfreq"
            onClick={() => {
              setOption('recurring');
            }}
            selected={option === 'recurring'}
          >
            <FormattedMessage
              description="Label for option to become a recurring donor"
              defaultMessage="Recurring monthly"
            />
          </OptionButtonWithRadio>
        </Group>
        <P>
          <FormattedMessage
            description="Copy for how often tips are charged"
            defaultMessage="You can change or cancel a subscription at any time. No surprises."
          />
        </P>
        <div className={css({display: 'flex', justifyContent: 'flex-end'})}>
          <Button
            disabled={option === null}
            onClick={() => {
              onChange(option!);
              setPending(true);
            }}
            pending={pending}
          >
            <FormattedMessage
              description="Button to move to the next step"
              defaultMessage="Continue"
            />
          </Button>
        </div>
      </VerticalGroup>
    </>
  );
};

export default TipFrequency;
